<div #container>
  <nav mat-tab-nav-bar>
    <a mat-tab-link *ngFor="let header of (headers$|async); let i = index"
      [active]="i == selectedIndex"
      (click)="onHeaderClick(i)">
      <div class="d-flex w-100 align-items-center">
        {{ header.label }}
      </div>
    </a>
  </nav>
</div>